<script>

  import Landing from './Landing.svelte';
  import items from '../data/items.js';

  export let updateActive;
  export let active;

  let mobileMenu = false;

  let w;
  let i,j,k;

  let list = [0,1,2];

  $: for (i=-1, j=0; j<list.length; i++, j++) {
      k = active+i;
      k < 0 ? k += items.length : "";
      k >= items.length ? k -= items.length : "";
      list[j] = k;
    }

</script>

<style type="text/sass">

.header-wrap
  height: 80px
  position: fixed
  width: 100%
  z-index: 10

ul
  display: flex
  color: white
  list-style: none
  margin: 0
  padding: 0
  height: 100%

li
  flex: 1
  display: flex
  align-items: center
  justify-content: space-around
  color: white
  opacity: 0.5
  cursor: pointer
  text-transform: uppercase
  white-space: nowrap
  user-select: none
  font-weight: 600
  font-size: 18px
  transition-duration: 0.3s
  transition-timing-function: ease-out

  &:hover
    transform: scale(1.04)

.active
  opacity: 1
  font-size: 22px
  font-weight: 700

.slide
  animation: slide-side 1s linear 1 forwards

@keyframes slide-top
  from
    bottom: 100%
  to
    bottom: 0%
    top: 80px

@keyframes slide-side
  from
    left: 25%
    opacity: 0
  to
    left: 0
    opacity: 1

.modal
  z-index: 1
  opacity: 1
  min-height: 80vh
  width: 100vw
  box-sizing: border-box
  font-size: 20px
  line-height: 1.5
  transition-duration: 0.5s
  border-top: 2px solid white
  position: fixed
  animation: slide-top 0.2s ease-out 1 both

.menu
  color: white
  text-transform: uppercase
  white-space: nowrap
  user-select: none
  font-weight: 600
  font-size: 20px
  line-height: 80px

.flex-cv
  display: flex
  flex-direction: column
  text-align: center

.flex-1
  flex: 1

.nav-left, .nav-right
  padding: 18px 15px
  cursor: pointer
  transition-duration: 0.3s
  transition-timing-function: ease-out

  &:hover
    transform: scale(1.2)

.nav-left
  float: left
.nav-right
  float: right

.dropdown-btn
  position: absolute
  top: 5px
  padding-left: 9px

</style>

<div class="header-wrap" bind:clientWidth={w} style="background: {items[active].color}">

  <svg on:click={() => updateActive(list[0])} class="nav-left" version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="white"><path d="M17 11h-7.586l2.293-2.293c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-4.707 4.707 4.707 4.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-2.293-2.293h7.586c.552 0 1-.448 1-1s-.448-1-1-1z"/></svg>
  <svg on:click={() => updateActive(list[2])} class="nav-right" version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="white"><path d="M13.293 7.293c-.391.391-.391 1.023 0 1.414l2.293 2.293h-7.586c-.552 0-1 .448-1 1s.448 1 1 1h7.586l-2.293 2.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l4.707-4.707-4.707-4.707c-.391-.391-1.023-.391-1.414 0z"/></svg>

  <ul class="flex">
    {#if w < 900}
      <li
        id={items[active].id}
        class="active"
        on:click={() => mobileMenu = !mobileMenu }
      >
        <span style="position: relative">
          {items[active].name}
          <svg class="dropdown-btn" version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M5.8 9.7l6.2 6.3 6.2-6.3c.2-.2.3-.5.3-.7s-.1-.5-.3-.7c-.2-.2-.4-.3-.7-.3h-11c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7s.1.5.3.7z"/></svg>
        </span>
      </li>
    {:else}
      {#each list as i}
        <li
          id={items[i].id}
          class:active={active == items[i].id}
          on:click={() => updateActive(items[i].id)}
        >
          {items[i].name}
        </li>
      {/each}
    {/if}
  </ul>
</div>

{#if mobileMenu}
  <div class="modal">
    <div class="menu flex-cv">
      {#each items as item, i}
        <div
          class="item ptr flex-cv flex-1"
          style="color: {i==active ? item.color : '#fff'}; background: {i!=active ? item.color : '#fff'}; box-shadow: {i==active ? 'inset 0 0 0 2px'+item.color : 'none'}"
          on:click="{() => {
            updateActive(items[i].id);
            mobileMenu = false;
          }}"
        >
          {item.name}
        </div>
      {/each}
    </div>
  </div>
{/if}
